import { jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
const SendButton = (props) => {
  return /* @__PURE__ */ jsx("button", { onClick: props.onClick, disabled: props.disabled, children: "Send" });
};
SendButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};
export {
  SendButton as default
};
//# sourceMappingURL=SendButton.js.map
